import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { MarketplaceGrid } from '@features/connections/generic/components/MarketplaceGrid';
import { useTutorialStore } from '../../../../application/store/TutorialStore';
import { APP_CONFIG } from '../../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';
import SalesOnboardingPanel from './SalesOnboardingPanel';

const SalesConnectStoreOverlay: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;
  const queryClient = useQueryClient();
  const markStepCompleted = useTutorialStore((s) => s.markStepCompleted);

  return (
    <SalesOnboardingPanel
      title="Connect to your store"
      footer={
        <Stack direction="row" flex={1} gap={1} alignItems="flex-start">
          <Icon icon="AlertCircle" size={IconSize.MEDIUM} color={colors.secondaryText} />
          <Typography variant="body2" color={colors.secondaryText}>
            We load all your data needed to start automatically from your store
          </Typography>
        </Stack>
      }
    >
      <Typography variant="body2" color="text.secondary">
        Be able to see all the data available
      </Typography>

      <MarketplaceGrid
        onNewConnection={() => {
          markStepCompleted('marketplace-connection');
          queryClient.invalidateQueries({ queryKey: ['connections'] });
        }}
      />
    </SalesOnboardingPanel>
  );
};

export default SalesConnectStoreOverlay;
